'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _jsx2 = require('babel-runtime/helpers/jsx');

var _jsx3 = _interopRequireDefault(_jsx2);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

exports.default = PageHeader;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _classnames = require('classnames');

var _classnames2 = _interopRequireDefault(_classnames);

require('./page-header.scss');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * WH PageHeader Component.
 * @param {Object} props The new component properties.
 * @returns {React$Element<any>} HTML markup for the component
 */
function PageHeader(props) {
    var _cx;

    var _props$className = props.className,
        className = _props$className === undefined ? '' : _props$className,
        _props$id = props.id,
        id = _props$id === undefined ? '' : _props$id,
        _props$style = props.style,
        style = _props$style === undefined ? '' : _props$style,
        _props$isSubHeader = props.isSubHeader,
        isSubHeader = _props$isSubHeader === undefined ? false : _props$isSubHeader,
        _props$onClick = props.onClick,
        onClick = _props$onClick === undefined ? function () {} : _props$onClick;


    var classNames = (0, _classnames2.default)((_cx = {
        'sb-page-header': true,
        'sb-page-header--subheader': isSubHeader
    }, (0, _defineProperty3.default)(_cx, 'sb-page-header--' + style, style), (0, _defineProperty3.default)(_cx, '' + className, className), _cx));

    return (0, _jsx3.default)('header', {
        className: classNames,
        id: id,
        onClick: onClick
    }, void 0, props.children);
}
// css
//# sourceMappingURL=PageHeader.js.map


//////////////////
// WEBPACK FOOTER
// ./~/@wh/ui-components/dist/main/components/pageHeader/PageHeader.js
// module id = 587
// module chunks = 0